import React from "react";

const Checkbox = ({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  activeLabel = "Aktif",
  inactiveLabel = "Pasif",
}) => {
  const handleToggle = () => {
    if (disabled || !onChange) return;
    onChange({ target: { checked: !checked } });
  };

  const displayLabel =
    label !== undefined ? label : checked ? activeLabel : inactiveLabel;

  return (
    <div
      className={`flex items-center gap-3 ${
        disabled ? "opacity-60 pointer-events-none" : ""
      } ${className}`}
    >
      <span
        className={`text-xs font-medium whitespace-nowrap ${
          checked ? "text-emerald-600" : "text-gray-400"
        }`}
      >
        {displayLabel}
      </span>
      <button
        type="button"
        onClick={handleToggle}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 shrink-0 ${
          checked ? "bg-indigo-600" : "bg-gray-300"
        }`}
        aria-pressed={checked}
        aria-label={typeof displayLabel === "string" ? displayLabel : undefined}
        disabled={disabled}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition duration-200 ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};

export default Checkbox;
